/** Siempre permite vista previa (incluido «Todos los productos»). */
export function isBulkPreviewScopeAllowed(_category: string | 'all', _search: string): boolean {
  return true;
}

/** @deprecated Ya no se bloquea el alcance; se mantiene por compat de exports. */
export const bulkPreviewScopeHint =
  'Revisá la vista previa antes de confirmar. El coeficiente solo toca productos con precio cargado.';

export const bulkAllCatalogWarning =
  'Vas a incluir todo el catálogo que tenga precio cargado — los productos sin precio no se tocan. Filtrá por categoría o nombre si querés menos, y mirá la vista previa antes de confirmar.';
